module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("通用组件")]), _vm._v(" "), _c('h2', [_vm._v("警告提示框 - <uk-alert>")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('uk-alert', {
    attrs: {
      "color": _vm.color,
      "closable": _vm.closable
    }
  }, [_vm._v("注：这是一段警告提示文字。\n  ")]), _vm._v(" "), _c('h3', [_vm._v("代码示例")]), _vm._v(" "), _c('code-block', [_vm._v(_vm._s(_vm.usages.alert))]), _vm._v(" "), _c('h3', [_vm._v("属性")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-striped uk-table-condensed"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('td', [_vm._v("可关闭")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.closable),
      expression: "closable"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.closable) ? _vm._i(_vm.closable, null) > -1 : (_vm.closable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.closable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.closable = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.closable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.closable = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('td', [_vm._v("颜色")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.color),
      expression: "color"
    }],
    staticClass: "uk-width-1-1",
    on: {
      "change": function($event) {
        _vm.color = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', [_vm._v("undefined")]), _vm._v(" "), _c('option', [_vm._v("success")]), _vm._v(" "), _c('option', [_vm._v("warning")]), _vm._v(" "), _c('option', [_vm._v("danger")])])])])])]), _vm._v(" "), _c('h2', [_vm._v("图标 - <uk-icon>")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('uk-icon', {
    attrs: {
      "name": _vm.name,
      "button": _vm.button,
      "hover": _vm.hover,
      "justify": _vm.justify,
      "spin": _vm.spin,
      "size": _vm.size
    }
  })], 1), _vm._v(" "), _c('code-block', [_vm._v(_vm._s(_vm.usages.icon.basic))]), _vm._v(" "), _c('h3', [_vm._v("属性")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-striped uk-table-condensed"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('td', [_vm._v("可关闭")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.button),
      expression: "button"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.button) ? _vm._i(_vm.button, null) > -1 : (_vm.button)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.button,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.button = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.button = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.button = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hover),
      expression: "hover"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.hover) ? _vm._i(_vm.hover, null) > -1 : (_vm.hover)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.hover,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.hover = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.hover = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.hover = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.justify),
      expression: "justify"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.justify) ? _vm._i(_vm.justify, null) > -1 : (_vm.justify)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.justify,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.justify = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.justify = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.justify = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spin),
      expression: "spin"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.spin) ? _vm._i(_vm.spin, null) > -1 : (_vm.spin)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.spin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.spin = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.spin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.spin = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('td', [_vm._v("尺寸")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.size),
      expression: "size"
    }],
    staticClass: "uk-width-1-1",
    on: {
      "change": function($event) {
        _vm.size = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', [_vm._v("undefined")]), _vm._v(" "), _c('option', [_vm._v("small")]), _vm._v(" "), _c('option', [_vm._v("medium")]), _vm._v(" "), _c('option', [_vm._v("large")])])])]), _vm._v(" "), _c('tr', [_vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('td', [_vm._v("图标")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "uk-width-1-1",
    on: {
      "change": function($event) {
        _vm.name = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', [_vm._v("undefined")]), _vm._v(" "), _c('option', [_vm._v("spinner")]), _vm._v(" "), _c('option', [_vm._v("comment")]), _vm._v(" "), _c('option', [_vm._v("edit")]), _vm._v(" "), _c('option', [_vm._v("check")]), _vm._v(" "), _c('option', [_vm._v("cloud-upload")]), _vm._v(" "), _c('option', [_vm._v("clone")]), _vm._v(" "), _c('option', [_vm._v("cart-plus")]), _vm._v(" "), _c('option', [_vm._v("credit-card")]), _vm._v(" "), _c('option', [_vm._v("plus")])])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "uk-margin-large-top"
  }, [_vm._v("徽章 - <uk-badge>")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('uk-badge', {
    attrs: {
      "color": _vm.badgeColor
    }
  }, [_vm._v("注意")])], 1), _vm._v(" "), _c('code-block', [_vm._v(_vm._s(_vm.usages.badge.basic))]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-striped uk-table-condensed"
  }, [_vm._m(26), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('td', [_vm._v("颜色")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.badgeColor),
      expression: "badgeColor"
    }],
    staticClass: "uk-width-1-1",
    on: {
      "change": function($event) {
        _vm.badgeColor = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', [_vm._v("undefined")]), _vm._v(" "), _c('option', [_vm._v("primary")]), _vm._v(" "), _c('option', [_vm._v("success")]), _vm._v(" "), _c('option', [_vm._v("danger")])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("属性")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', {
    staticClass: "uk-width-2-6"
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("体验")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("closable")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("Boolean")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("false")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("undefined")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("属性")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', {
    staticClass: "uk-width-2-6"
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("体验")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("button")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("Boolean")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("false")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("hover")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("Boolean")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("false")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("justify")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("Boolean")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("false")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("spin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("Boolean")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("false")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("size")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("undefined")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("undefined")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("属性")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', {
    staticClass: "uk-width-2-6"
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("体验")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("undefined")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8e8e5d70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/docs/Common.vue
// module id = 299
// module chunks = 2